import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {MultipageTemplateSubmissionUnavailablePanelProps} from '@Panels/multipage-template-submission-unavailable-panel/multipage-template-submission-unavailable-panel.types';
import {MULTIPAGE_TEMPLATE_SUBMISSION_UNAVAILABLE_PANEL_ID} from '@Panels/multipage-template-submission-unavailable-panel/multipage-template-submission-unavailable-panel.types';

export {MULTIPAGE_TEMPLATE_SUBMISSION_UNAVAILABLE_PANEL_ID};

export const openMultipageTemplateSubmissionUnavailableModal = (props: MultipageTemplateSubmissionUnavailablePanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.MULTIPAGE_TEMPLATE_SUBMISSION_UNAVAILABLE_MODAL,
      panelProps: {...props},
    })
  );
};

export const checkIfUserAllowedMultipageSubmissions = async (): Promise<boolean> => {
  try {
    const res = (await window.PMW.readLocal('sell/isUserAllowedMultipageSubmissions')) as {multipage_submissions_allowed: boolean};
    return res.multipage_submissions_allowed;
  } catch (e) {
    console.error(e);
  }
  return false;
};